/**
 * abilityVfxSpellShield — Sivir E Spell Shield cyan magical bubble (SP-19).
 */
export function buildSpellShield(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.45);
  const cyan = mat(THREE, spec.color || 0x38bdf8, 0.42);
  const pale = mat(THREE, 0xbae6fd, 0.7);
  const deep = mat(THREE, 0x0ea5e9, 0.55);
  addBubbleDome(THREE, group, s, cyan, pale);
  addRimRings(THREE, group, s, pale, deep);
  addShimmerArcs(THREE, group, s, pale, deep);
  group.userData = { shape: 'spell_shield' };
  return group;
}

function addBubbleDome(THREE, group, s, cyan, pale) {
  const dome = new THREE.Mesh(new THREE.SphereGeometry(s, 14, 12), cyan);
  dome.position.y = 0.5 * s;
  group.add(dome);
  const core = new THREE.Mesh(new THREE.SphereGeometry(s * 0.28, 10, 10), pale);
  core.position.y = 0.55 * s;
  group.add(core);
}

function addRimRings(THREE, group, s, pale, deep) {
  const foot = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.45, s * 1.05, 24).rotateX(-Math.PI / 2),
    deep
  );
  foot.position.y = 0.05;
  group.add(foot);
  const belt = new THREE.Mesh(new THREE.TorusGeometry(s * 0.85, 0.04 * s, 8, 20), pale);
  belt.position.y = 0.45 * s;
  belt.rotation.x = Math.PI / 2;
  group.add(belt);
}

function addShimmerArcs(THREE, group, s, pale, deep) {
  for (let i = 0; i < 4; i += 1) {
    const a = (Math.PI / 2) * i + 0.2;
    const arc = new THREE.Mesh(new THREE.BoxGeometry(0.08 * s, 0.55 * s, 0.06 * s), pale);
    arc.position.set(Math.cos(a) * s * 0.7, 0.55 * s, Math.sin(a) * s * 0.7);
    group.add(arc);
    const spark = new THREE.Mesh(new THREE.SphereGeometry(0.07 * s, 8, 8), deep);
    spark.position.set(Math.cos(a) * s * 0.9, 0.75 * s, Math.sin(a) * s * 0.9);
    group.add(spark);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
